export default {
  shape: {
    value: "Rectangular",
    options: ["Radial", "Rectangular", "Curved"],
  },
  size: 0.6,
  outletLength: 50,
};
